// extracted by mini-css-extract-plugin
module.exports = {"container":"intro-module__container___-oWg5","image":"intro-module__image___T1D5A"};